import React, { useState, useEffect } from 'react';
import { Table, Button, Input, Modal, Spin, Row, Col, Tooltip } from 'antd';
import { EditOutlined, SearchOutlined } from '@ant-design/icons';
import apiRequest from '../../hooks/ApiRequest';
import Layouts from '../../components/Layouts';
import AssignUserForm from './AddEditUser';

const AssignedUserList = () => {
  const [searchValue, setSearchValue] = useState('');
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedUserID, setSelectedUserID] = useState(null);

  useEffect(() => {
    fetchAssignedUsers();
  }, []);

  const fetchAssignedUsers = async () => {
    setLoading(true);
    try {
      const response = await apiRequest(process.env.REACT_APP_BASE_URL_AUTH+'/api/Auth/user-parent-list', 'GET');
      setUserData(response.data || []);
    } catch (error) {
      console.error('Error fetching assigned users', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    fetchAssignedUsers();
  };

  const handleCreateUser = () => {
    setSelectedUserID(null);
    setModalVisible(true);
  };

  const handleEditUser = userId => {
    setSelectedUserID(userId);
    setModalVisible(true);
  };

  const handleModalClose = () => {
    setModalVisible(false);
    fetchAssignedUsers();
  };

  const columns = [
    {
      title: 'User Name',
      key: 'userName',
      render: (_, record) => `${record.userFirstName} ${record.userLastName}`,
    },
    {
      title: 'User Email',
      dataIndex: 'userEmail',
      key: 'userEmail',
    },
    {
      title: 'Parent Name',
      key: 'parentName',
      render: (_, record) => `${record.parentFirstName} ${record.parentLastName}`,
    },
    {
      title: 'Parent Email',
      dataIndex: 'parentEmail',
      key: 'parentEmail',
    },
  ];

  return (
    <Layouts title="Assigned Users" classname="dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <h3 style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
              Assigned Users
            </h3>
          </Col>
          <Col xs={24} sm={24} md={24} lg={7}>
            <Input.Search
              placeholder="Search ..."
              prefix={<SearchOutlined />}
              value={searchValue}
              onChange={e => setSearchValue(e.target.value)}
            />
          </Col>
          <Col xs={24} sm={24} md={3} lg={2}>
            <Button type="primary" onClick={handleSearch} style={{ marginLeft: 10 }}>
              Search
            </Button>
          </Col>
          <Col xs={24} sm={24} md={3} lg={2}>
            <Button type="primary" onClick={handleCreateUser}>
              Assign User
            </Button>
          </Col>
        </Row>
      </div>

      {loading ? (
        <Spin size="large" style={{ display: 'block', marginTop: 20 }} />
      ) : (
        <Table columns={columns} dataSource={userData} rowKey="userId" />
      )}

      <Modal
        title={selectedUserID ? 'Edit Assigned User' : 'Assign New User'}
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}
      >
        <AssignUserForm assignID={selectedUserID} onSuccess={handleModalClose} modalVisible={modalVisible} />
      </Modal>
    </Layouts>
  );
};

export default AssignedUserList;
